/* DSL Mobile-nav variant C — side-by-side cart+menu icons in header */
(function(){
  if (window.matchMedia("(min-width: 750px)").matches) return;
  if (!window.DSL_AB) return;
  var v = window.DSL_AB.getVariant("mobile_nav_v2", ["A","B","C"]);
  if (v !== "C") return;
  var hdr = document.querySelector(".header-wrapper, header");
  if (!hdr) return;
  hdr.classList.add("dsl-mobile-nav-c");
})();